import * as React from "react";
import ShiftCode from "../../presentations/ShiftCode";

const ShiftCodeContainer = (props: any) => {
  const { data } = props;

  return (
    <div>
      <ShiftCode data={data}></ShiftCode>
    </div>
  );
};

export default ShiftCodeContainer;
